import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useAuth } from '~/routes/components/AuthProvider';
import Dialog from '../Dialog';
import { CountdownWrapper, StyledTimerWrapper } from './style';
import ReactCountdownClock from 'react-countdown-clock'
import { ThemeContext } from 'styled-components';

interface TimerProps {
  logoutTime: number
}

const Timer: React.FC<TimerProps> = (props) => {
  const { t } = useTranslation()
  const { onLogout } = useAuth()
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const increment = useRef(null);
  const logoutTime = useRef(null)
  const openModalRef = useRef(null);
  const { firstColor } = useContext(ThemeContext)
  const [openCountdownModal, setOpenCountdownModal] = useState(false)
  const handleStart = () => {
    const dateNow = new Date()
    increment.current = setInterval(() => getTime(dateNow), 1000)
  }

  const handleClick = useCallback(() => {
    if (!openModalRef.current) {
      clearInterval(increment.current)
      handleStart()
    }
  }, []);

  useEffect(() => {
    openModalRef.current = openCountdownModal
  }, [openCountdownModal])

  useEffect(() => {
    handleStart()
  }, [])

  useEffect(() => {
    logoutTime.current = props.logoutTime
  }, [props.logoutTime])

  useEffect(() => {
    window.addEventListener('click', () => handleClick())
    window.addEventListener('scroll', () => handleClick())
    return () => {
      window.removeEventListener('click', () => handleClick())
      window.removeEventListener('scroll', () => handleClick())
    }
  }, [handleClick])

  useEffect(() => {
    if (minutes === 0 && seconds === 30 && !openCountdownModal) {
      setOpenCountdownModal(true)
    }
    else if (minutes === 0 && seconds === 1) {
      onLogout()
    }
  }, [minutes, openCountdownModal, seconds])

  const getTime = (dateNow) => {
    const logoutTimeA = logoutTime.current || props.logoutTime
    const dateLogout = new Date(dateNow.getTime() + logoutTimeA * 60000)
    const time = dateLogout.getTime() - Date.now()
    if (time >= 0) {
      setMinutes(Math.floor((time / 1000 / 60) % 60));
      setSeconds(Math.floor((time / 1000) % 60));
    } else {
      setMinutes(0)
      setSeconds(1)
    }
  };

  function renderModal() {
    return <Dialog
      open={openCountdownModal}
      handleClose={() => {
        setOpenCountdownModal(false)
        onLogout()
      }}
      handleSubmit={() => {
        setOpenCountdownModal(false)
        clearInterval(increment.current)
        handleStart()
      }}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      hideCloseIcon
      textSubmit={t('Extend session')}
      textHeader={t('Logout timer')}
      textClose={t('Logout')}
      htmlContent
      textContent={<CountdownWrapper>
        <div className='countdown'>
          <ReactCountdownClock seconds={30}
            color={firstColor}
            alpha={0.9}
            size={150}
            onComplete={() => onLogout()} />
        </div>
        <div className='text'>
          {t('If you are inactive for longer than {{logoutTime}}:00 minutes, you will be automatically logged out for security reasons.', { logoutTime: props.logoutTime })}
        </div>
      </CountdownWrapper>}
    />
  }

  return <StyledTimerWrapper>
    <div className='timer' role='timer'>
      <div className='col-4'>
        <div className='box'>
          <p id='minute'>{minutes < 10 ? '0' + minutes : minutes}</p>
          <span className='text'>{t('Minutes')}</span>
        </div>
      </div>
      <div className='col-4'>
        <div className='box'>
          <p id='second'>{seconds < 10 ? '0' + seconds : seconds}</p>
          <span className='text'>{t('Seconds')}</span>
        </div>
      </div>
    </div>
    {setOpenCountdownModal && renderModal()}
  </StyledTimerWrapper>
};
export default Timer